import { DemoWorkspace } from './types';

export const DEMO_WORKSPACE_INITIAL_DATA: DemoWorkspace[] = [
  {
    id: 'float16-team',
    name: 'Float16 Team',
    organizationId: 'float16-inc',
    type: 'workspace',
    role: 'Admin',
    quota: {
      h200: { total: 4, used: 3 },
      a100: { total: 8, used: 2 },
      l4: { total: 16, used: 5 },
    },
    instances: [
      { name: 'h200-gpu-01 (Dual 71GB)', type: 'H200 MIG', count: 2, status: 'running' },
      { name: 'h200-gpu-02 (Full GPU)', type: 'H200 MIG', status: 'running' },
      { name: 'h200-gpu-03 (Multi-tenant)', type: 'H200 MIG', count: 5, status: 'running' },
      { name: 'prod-ml-training', type: 'A100 80GB', status: 'running' },
    ],
    members: [
      {
        id: 'member-1',
        email: 'admin@float16.cloud',
        name: 'Admin User',
        role: 'Owner',
        permissions: { read: true, create: true, delete: true },
        joinedAt: '2024-01-15T10:00:00Z',
      },
      {
        id: 'member-2',
        email: 'developer@float16.cloud',
        name: 'Developer One',
        role: 'Admin',
        permissions: { read: true, create: true, delete: true },
        joinedAt: '2024-02-20T14:30:00Z',
      },
      {
        id: 'member-3',
        email: 'analyst@float16.cloud',
        name: 'Data Analyst',
        role: 'Member',
        permissions: { read: true, create: true, delete: false },
        joinedAt: '2024-03-10T09:15:00Z',
      },
      {
        id: 'member-4',
        email: 'intern@float16.cloud',
        name: 'ML Intern',
        role: 'Viewer',
        permissions: { read: true, create: false, delete: false },
        joinedAt: '2024-06-01T08:00:00Z',
      },
    ],
    createdAt: '2024-01-01T00:00:00Z',
  },
  {
    id: 'ml-research',
    name: 'ML Research',
    organizationId: 'float16-inc',
    type: 'workspace',
    role: 'Member',
    quota: {
      h200: { total: 2, used: 1 },
      a100: { total: 4, used: 2 },
      l4: { total: 8, used: 3 },
    },
    instances: [
      { name: 'research-notebook', type: 'A100 80GB', status: 'running' },
    ],
    members: [
      {
        id: 'member-research-1',
        email: 'researcher@float16.cloud',
        name: 'ML Researcher',
        role: 'Owner',
        permissions: { read: true, create: true, delete: true },
        joinedAt: '2024-03-01T00:00:00Z',
      },
    ],
    createdAt: '2024-03-01T00:00:00Z',
  },
  {
    id: 'personal',
    name: 'matichon',
    organizationId: 'personal-org',
    type: 'personal',
    quota: {
      h200: { total: 1, used: 0 },
      a100: { total: 2, used: 1 },
      l4: { total: 4, used: 2 },
    },
    instances: [
      { name: 'dev-notebook', type: 'A100 80GB', status: 'running' },
      { name: 'test-inference', type: 'L4', status: 'running' },
    ],
    members: [
      {
        id: 'member-owner',
        email: 'matichon@float16.cloud',
        name: 'Matichon',
        role: 'Owner',
        permissions: { read: true, create: true, delete: true },
        joinedAt: '2024-01-01T00:00:00Z',
      },
    ],
    createdAt: '2024-01-01T00:00:00Z',
  },
];
